import React from "react";
import { Route, Redirect } from "react-router-dom";

export default function FranqueadoOnlyRoute({ component: Component, auth, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        auth.authenticated === true && auth.data.tipo === "franqueado" ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/login" }} />
        )
      }
    />
  );
}
